export default defineNuxtRouteMiddleware((to, from) => {
  const { $pb } = useNuxtApp();
  // console.log($pb.authStore);
  // console.log('to from', to, from);
  const loginRoutes = ['login', 'sign-up'];
  const accountRoutes = ['account-dashboard', 'account-delivery', 'account-history', 'account-history-order', 'account-referral'];
  const panelRoutes = ['panel-dashboard', 'panel-order-list', 'panel-order-list-order', 'panel-dashboard-order'];

  if ($pb.authStore.isValid && (loginRoutes.includes(to.name as string))) {
    // console.log('abort navigation', from);
    return navigateTo('/');
  }

  if (!$pb.authStore.isValid && (loginRoutes.includes(to.name as string)) && !to.redirectedFrom) {
    // console.log('normal login', to, from);
    // return navigateTo('/login', {
    //   replace: true,
    //   redirectCode: 401,
    // });
  }

  if (!$pb.authStore.isValid && (accountRoutes.includes(to.name as string))) {
    return navigateTo('/login', {
      redirectCode: 401,
    });
  }

  if (!$pb.authStore.isValid && (panelRoutes.includes(to.name as string))) {
    return navigateTo('/login', {
      redirectCode: 401,
    });
  }

  if ($pb.authStore.isValid && !$pb.authStore?.model?.isAdmin && (panelRoutes.includes(to.name as string))) {
    return navigateTo('/');
  }
});
